import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (<div className="app-error">SOMETHING WENT WRONG. PLEASE CONTACT SUPPORT.</div>);
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
